import React from 'react';
import '../../styles/RateCard.css';

const OptionsBeAds = () => {
    return (
        <section className="options-be-ads-section py-5">
            <div className="container">
                <h2 className="title text-white text-capitalize mb-4" data-aos="fade-up" data-aos-delay="200">
                    Opciones de contratación<br /><span className="highlight-bg">Be Ads</span>
                </h2>

                <div className="table-responsive" data-aos="fade-up" data-aos-delay="200">
                    <table className="table table-bordered text-center align-middle">
                        <thead className="table-success text-white">
                            <tr>
                                <th className='pt-4 pb-4'>Formato</th>
                                <th className='pt-4 pb-4'>Ubicaciones</th>
                                <th className='pt-4 pb-4'>Dispositivo</th>
                                <th className='pt-4 pb-4'>Tipo de compra</th>
                                <th className='pt-4 pb-4'>Precio</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Display Banners</td>
                                <td>Home / Interiores / ROS</td>
                                <td>Desktop & Mobile</td>
                                <td>
                                    <strong>Paquete de 50k</strong><br /> impresiones.<br /><br />
                                    <strong>Paquete de 20k</strong><br /> impresiones.
                                </td>
                                <td className="fw-bold text-success">Consultar</td>
                            </tr>
                            <tr>
                                <td>Rich Media Banners</td>
                                <td>Home | Interiores | ROS</td>
                                <td>Desktop & Mobile</td>
                                <td>
                                    <strong>Paquete de 50k</strong><br /> impresiones.<br /><br />
                                    <strong>Paquete de 20k</strong><br /> impresiones.
                                </td>
                                <td className="fw-bold text-success">Consultar</td>
                            </tr>
                            <tr>
                                <td>Video Banners</td>
                                <td>Home | Interiores | ROS</td>
                                <td>Desktop & Mobile</td>
                                <td>
                                    <strong>Paquete 20K <br />Visualizaciones</strong>
                                </td>
                                <td className="fw-bold text-success">Consultar</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default OptionsBeAds;

